import {GlobalVariables} from "../GlobalVariables";
import Header from "./Header";

export default class NavsFull {
	constructor() {
		this.header = document.querySelector(".header-main-burger");

		if (this.header) {
			this.toggleMobileNav();
			GlobalVariables.resizeCallbacks.push(this);
		}
	}

	toggleMobileNav() {
		const openTrigger = document.querySelector(".nav-main-toggle");
		if (openTrigger) {
			openTrigger.addEventListener("click", () => {
				if (document.body.classList.contains("navs-open")) {
					this.closeNav();
				} else {
					this.openNav();
				}
			});
		}

		const lev1Parents = this.header.querySelectorAll(".nav-main .menu-item-lev1.menu-item-has-children");
		lev1Parents.forEach(link => {
			const target = link.querySelector("a.target");
			const subnav = link.querySelector(".lev2");

			// subnav.dataset.height = subnav.clientHeight;
			// subnav.style.height = 0;

			target.addEventListener("click", (e) => {
				if (window.innerWidth <= 991) {
					e.preventDefault();

					if (!link.classList.contains("active")) {
						link.classList.add("active");
						if (subnav) {
							subnav.classList.add("show");
						}
					} else {
						link.classList.remove("active");
						if (subnav) {
							subnav.classList.remove("show");
						}
					}
				}
			});
		});
	}

	openNav() {
		document.body.classList.add("navs-open");
		GlobalVariables.header.makeHeaderAsBannerTheme();

		GlobalVariables.lenis?.stop();
	}

	closeNav() {
		document.body.classList.remove("navs-open");
		GlobalVariables.header.restoreHeaderTheme();

		GlobalVariables.lenis?.start();
	}

	resize() {
		this.closeNav();
	}
}
